module.exports = __webpack_public_path__ + "img/shrimp-2.21ce64e0.png";